<template>
	<div class="main-container">
		<v-btn class="login-btn" color="#e79831" text small @click="toLogin()">Log in</v-btn>
		<img class="logo" src="../assets/LensAdvisors_cropped.svg" alt />
		<div class="title">
			<h1>
				Compare prices among the leading
				<span class="secondary-title">contact lens</span> suppliers
			</h1>
		</div>

		<v-card class="search-container" outlined>
			<SearchBar class="search-bar" @input="onSearchChange" />
			<div class="filter-container">
				<SelectInput
					class="filter-select"
					:items="sharedState.types"
					placeholder="Types"
					v-on:change="onTypeFilterChange"
				></SelectInput>
				<SelectInput
					class="filter-select"
					:items="sharedState.brands"
					placeholder="Brands"
					v-on:change="onBrandFilterChange"
				></SelectInput>
				<!-- <SelectInput
					class="filter-select"
					:items="sharedState.manufacturers"
					placeholder="Manufacturers"
					v-on:change="onManufacturerFilterChange"
				></SelectInput>-->
			</div>
		</v-card>

		<AdComponent
			v-if="sharedState.adInfo.approved"
			v-bind="sharedState.adInfo"
			:imageUrl="sharedState.adInfo.image"
		/>

		<div class="grid-container">
			<div class="products-container" v-if="sharedState.loading">
				<v-skeleton-loader style="border: 1px solid #EFEFEF;" :type="'card'" v-for="i in 9" :key="i"></v-skeleton-loader>
			</div>
			<div class="products-container" v-if="!sharedState.loading">
				<GridListProduct
					v-for="product in sharedState.products"
					:key="product.id"
					v-bind:product="product"
				/>
			</div>
		</div>
	</div>
</template>


<script>
import SearchBar from "../components/SearchBar";
import GridListProduct from "../components/GridListProduct";
import SelectInput from "../components/SelectInput";
import store from "../services/product/store";
import AdComponent from "@/components/AdComponent";

export default {
	name: "MainPage",
	metaInfo() { 
		return {
			title:
				"LensAdvisors - Compare prices among the leading contact lens suppliers",
			meta: [
				{
					vmid: "description",
					name: "description",
					content:
						"Compare prices among the leading contact lens suppliers"
				},
				{
					vmid: "og:title",
					property: "og:title",
					content:
						"LensAdvisors - Compare prices among the leading contact lens suppliers"
				},
				{
					vmid: "og:description",
					property: "og:description",
					content:
						"Compare prices among the leading contact lens suppliers"
				},
				{
					vmid: "og:image",
					property: "og:image",
					content: `https://www.lensadvisors.com${require('@/assets/LensAdvisors.jpg')}`
				},
				{
					property: "og:image:width",
					content: "1060",
					vmid: "og:image:width"
				},
				{
					property: "og:image:height",
					content: "203",
					vmid: "og:image:height"
				},
				{
					vmid: "og:site_name",
					property: "og:site_name",
					content: "LensAdvisors"
				}
			]
		}
	},
	data: () => {
		return {
			model: null,
			sharedState: store.state
		};
	},
	components: {
		SearchBar,
		GridListProduct,
		SelectInput,
		AdComponent
	},
	methods: {
		toLogin() {
			this.$router.push("business/login");
		},
		onSearchChange(event) {
			store.setNameFilter(event);
			store.getProducts();
		},
		onBrandFilterChange(filtered) {
			store.setBrandFilter(filtered.map(item => item.id));
			store.getProducts();
		},
		onManufacturerFilterChange(filtered) {
			store.setManufacturerFilter(filtered.map(item => item.id));
			store.getProducts();
		},
		onTypeFilterChange(filtered) {
			store.setTypeFilter(filtered.map(item => item.id));
			store.getProducts();
		}
	},
	created() {
		if (this.sharedState.products.length === 0) store.getProducts();
		if (this.sharedState.brands.length === 0) store.getBrands();
		// if (this.sharedState.manufacturers.length === 0)
		// 	store.getManufacturers();
		if (this.sharedState.types.length === 0) store.getTypes();

		if (!this.sharedState.latitude && !this.sharedState.longitude) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					position => {
						store.setLatitude(position.coords.latitude);
						store.setLongitude(position.coords.longitude);
						store.getSpot(
							position.coords.latitude,
							position.coords.longitude
						);
					},
					() => {
						store.getSpot();
					}
				);
			} else {
				store.getSpot();
			}
		} else {
			store.getSpot(
				this.sharedState.latitude,
				this.sharedState.longitude
			);
		}
	}
};
</script>
<style lang="scss" scoped>
	.row {
		float: left;
	}
	.logo {
		position: absolute;
		top: 20px;
		left: 20px;
		cursor: pointer;
	}

	.login-btn {
		position: absolute;
		top: 20px;
		right: 20px;
	}

	.main-container {
		width: 80%;
		margin: 0 auto;
		margin-top: 120px;
		display: flex;
		flex-direction: column;
		align-content: center;

		.title {
			width: 85%;

			h1 {
				font-weight: bold;
				font-size: 6rem;
				line-height: 7rem;
				color: #18125a;
			}
		}

		.secondary-title {
			color: #e79831;
		}

		.search-container {
			justify-content: center;
			align-content: center;
			margin: 20px 0;
			padding: 80px 0px;
			box-sizing: border-box;

			.search-bar {
				margin: 0 auto;
			}
			.filter-container {
				width: 80%;
				margin: 15px auto 0px auto;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-items: flex-start;

				.select-input {
					float: left;
				}

				.filter-select {
					margin-right: 15px;
					margin-bottom: 10px;
				}
			}
		}

		h3 {
			margin-top: 50px;
			margin-bottom: 50px;
			font-size: 2.5rem;
			color: #18125a;
		}

		.grid-container {
			display: flex;
			margin: 25px 0px;

			.products-container {
				display: grid;
				justify-content: center;
				grid-template-columns: repeat(auto-fit, calc(33% - 25px));
				grid-template-rows: repeat(auto-fit, auto);
				gap: 25px;
				flex: 8;
				width: 100%;
			}

			.ads-container {
				flex: 2;
				width: 100%;
				background-color: gray;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.main-container {
			.title {
				h1 {
					font-size: 3rem;
					line-height: 4rem;
					margin: 0 auto;
				}
			}

			.grid-container {
				display: flex;
				flex-direction: column-reverse;

				.products-container {
					justify-content: center;
					grid-template-columns: repeat(auto-fit, calc(50% - 25px));
					grid-template-rows: repeat(auto-fit, auto);
					gap: 25px;
				}
			}
		}
	}

	@media screen and (max-width: 600px) {
		.logo {
			margin-top: 30px;
		}

		.main-container {
			width: 90%;
			margin-top: 150px;

			.title {
				width: 100%;

				h1 {
					font-size: 2.5rem;
					line-height: 3rem;
					margin: 0 auto;
				}
			}

			.search-container {
				width: 100%;
				margin: 20px auto;
				padding: 0px;
				box-sizing: border-box;
				box-shadow: none;

				// .search_bar {
				// 	height: 50px;
				// }

				.filter-container {
					justify-content: space-evenly;
					margin: 15px auto;
				}
			}

			h3 {
				display: none;
				margin-top: 20px;
				margin-bottom: 20px;
				font-size: 1.5rem;
			}

			.grid-container {
				.products-container {
					grid-template-columns: repeat(auto-fit, calc(50% - 5px));
					grid-template-rows: repeat(auto-fit, auto);
					gap: 5px;
				}
			}
		}
	}
</style>